/** Apre un URL nel browser di sistema. In Electron passa per il canale IPC
 *  ``omBridge.openExternal`` (whitelist poste.it lato main, perche'
 *  setWindowOpenHandler nega target=_blank); fuori da Electron (dev/browser)
 *  ripiega su ``window.open``. Esportata: riusata dalla card ordini
 *  (design B 2026-07-02) per il popup tracking. */
export function openExternalUrl(url: string): void {
  const bridge = (
    window as unknown as { omBridge?: { openExternal?: (u: string) => Promise<boolean> } }
  ).omBridge;
  if (bridge?.openExternal) {
    void bridge.openExternal(url);
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
